import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conducere-si-acces',
  templateUrl: './conducere-si-acces.component.html',
  styleUrls: ['./conducere-si-acces.component.scss']
})
export class ConducereSiAccesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
